// Shown in place of Business content when the organization has no active
// Business entitlement (or the entitlement read failed and the gate stayed
// closed). Business is its own plan slot; cloud and the AI platform are
// separate products and are not entitlements to this area.
import { Button } from "@sylviq/ui-react-web/components/ui/button";
import { PageHeader } from "@sylviq/ui-react-web/components/ui/page-header";
import { Link } from "@tanstack/react-router";
import { useBusinessEntitlement } from "@/lib/entitlement";

export function BusinessUpgrade() {
  const { error } = useBusinessEntitlement();
  return (
    <div className="mx-auto max-w-2xl px-6 py-12">
      <PageHeader
        title="Business is a paid plan"
        description="Business adds the business apps and the organization-management surface: legal entities, Extensions, and Developer access."
      />
      {error ? (
        <p
          role="alert"
          className="surface rounded-xl border border-[var(--danger)] p-4 text-sm text-[var(--danger)]"
        >
          We couldn&apos;t check your Business status ({error}). Nothing is
          unlocked while the check fails — try again in a moment.
        </p>
      ) : (
        <p className="text-sm text-[var(--muted-foreground)]">
          Your organization doesn&apos;t have a Business subscription yet.
          Pick a plan to open this area — your Apps stay available either way.
        </p>
      )}
      <div className="mt-6 flex flex-wrap gap-2">
        <Button asChild>
          <Link to="/pricing">See pricing</Link>
        </Button>
        <Button variant="secondary" asChild>
          <a href="/home">Back to apps</a>
        </Button>
      </div>
    </div>
  );
}
